import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle `
    * {
        color: #fff;
    }
    body {
        background-color: #212529;
    }
    a {
        text-decoration: none;
        color: #fff;
    }
`